import { gql } from '@apollo/client';

const getJsonSchemaQuery = gql `
      query MyQuery {
        core_DartJsonSchema(where: {dartid: {_eq: 2002}}) {
          jsonSchema
          uiSchema
        }
      }
`;

const getAlertDetailsQuery = gql`
query getAlertFormData($Id: Int!) {
    event_Notifications_new(where: {id: {_eq: $Id}}) {
      formDataEdit
    }
  }
`
const addAlertQuery = gql`
mutation MyMutation($formDataEdit: String , $variables: String ,$createdBy: String, $createdOn: Int, $name: String, $lastModified: Int, $status: String) {
    insert_event_Notifications_new(objects: {formDataEdit: $formDataEdit, variables: $variables, createdBy: $createdBy, createdOn: $createdOn, name: $name,lastModified: $lastModified, status: $status}) {
      affected_rows
    }
  }
`
const getAlertsListsQuery = gql `
query MyQuery($whereCondition:event_Notifications_new_bool_exp,$limit: Int!, $offset: Int! = 0) {
    event_Notifications_new(where: $whereCondition,limit: $limit, offset: $offset) {
      id
      name
      createdBy
      createdOn
      lastModified
      status
    }
  }
`
const getAlertsListsCnt = gql `
query MyQuery($whereCondition: event_Notifications_new_bool_exp) {
    event_Notifications_new(where: $whereCondition) {
      id
      formDataEdit
      variables
      scope
      group_include
      name
      createdBy
      createdOn
      lastModified
      status
    }
  }
`

const updateAlertQuery = gql`
mutation MyMutation($rowId: Int!,$formDataEdit: String,$variables: String,$createdBy: String,$createdOn: Int,$name: String,$lastModified: Int,$status: String) {
    update_event_Notifications_new(where: {id: {_eq:$rowId}}, _set: {createdBy:$createdBy,createdOn:$createdOn,formDataEdit:$formDataEdit,lastModified:$lastModified,name:$name,status:$status,variables:$variables}){
      returning {
        name
      }
    }
  }
`
const deleteAlertQuery = gql `
mutation MyMutation($id:[Int!] = []) {
    delete_event_Notifications_new(where: {id: {_in: $id}}) {
      affected_rows
    }
  }
  `

  const getPreviousResultIdQuery = gql `query MyQuery {
    event_Notifications_new(order_by: {createdOn: desc}, limit: 1) {
      id
    }
  }
    `

export {getPreviousResultIdQuery,getJsonSchemaQuery,addAlertQuery,getAlertsListsQuery,getAlertDetailsQuery,updateAlertQuery,deleteAlertQuery,getAlertsListsCnt}

